import { render, staticRenderFns } from "./MingShi.vue?vue&type=template&id=369cb4d5&scoped=true&"
import script from "./MingShi.vue?vue&type=script&lang=js&"
export * from "./MingShi.vue?vue&type=script&lang=js&"
import style0 from "./MingShi.vue?vue&type=style&index=0&id=369cb4d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369cb4d5",
  null
  
)

export default component.exports